import _classCallCheck from "/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/assertThisInitialized";
import _inherits from "/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table/ui/inserttableview
 */
import View from '@ckeditor/ckeditor5-ui/src/view';
import "./../../theme/inserttable.css";
/**
 * The table size view.
 *
 * It renders a 10x10 grid to choose the inserted table size.
 *
 * @extends module:ui/view~View
 * @implements module:ui/dropdown/dropdownpanelfocusable~DropdownPanelFocusable
 */

var InsertTableView =
/*#__PURE__*/
function (_View) {
  _inherits(InsertTableView, _View);

  /**
   * @inheritDoc
   */
  function InsertTableView(locale) {
    var _this;

    _classCallCheck(this, InsertTableView);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InsertTableView).call(this, locale));
    var bind = _this.bindTemplate;
    /**
     * A collection of table size box items.
     *
     * @readonly
     * @member {module:ui/viewcollection~ViewCollection}
     */

    _this.items = _this.createCollection();
    /**
     * The currently selected number of rows of the new table.
     *
     * @observable
     * @member {Number} #rows
     */

    _this.set('rows', 0);
    /**
     * The currently selected number of columns of the new table.
     *
     * @observable
     * @member {Number} #columns
     */


    _this.set('columns', 0);
    /**
     * The label text displayed under the boxes.
     *
     * @observable
     * @member {String} #label
     */


    _this.bind('label').to(_assertThisInitialized(_this), 'columns', _assertThisInitialized(_this), 'rows', function (columns, rows) {
      return "".concat(rows, " \xD7 ").concat(columns);
    });

    _this.setTemplate({
      tag: 'div',
      attributes: {
        class: ['ck']
      },
      children: [{
        tag: 'div',
        attributes: {
          class: ['ck-insert-table-dropdown__grid']
        },
        children: _this.items
      }, {
        tag: 'div',
        attributes: {
          class: ['ck-insert-table-dropdown__label']
        },
        children: [{
          text: bind.to('label')
        }]
      }],
      on: {
        mousedown: bind.to(function (evt) {
          evt.preventDefault();
        }),
        click: bind.to(function () {
          _this.fire('execute');
        })
      }
    }); // Add grid boxes to table selection view.


    var _loop = function _loop(index) {
      var boxView = new TableSizeGridBoxView(); // Listen to box view 'over' event which indicates that mouse is over this box.

      boxView.on('over', function () {
        // Translate box index to the row & column index.
        var row = Math.floor(index / 10);
        var column = index % 10; // As row & column indexes are zero-based transform it to number of selected rows & columns.

        _this.set('rows', row + 1);

        _this.set('columns', column + 1);
      });

      _this.items.add(boxView);
    };

    for (var index = 0; index < 100; index++) {
      _loop(index);
    }

    _this.on('change:columns', function () {
      _this._highlightGridBoxes();
    });

    _this.on('change:rows', function () {
      _this._highlightGridBoxes();
    });

    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(InsertTableView, [{
    key: "focus",
    value: function focus() {} // The dropdown panel expects DropdownPanelFocusable interface on views passed to dropdown panel. See #30.
    // The method should be implemented while working on keyboard support for this view. See #22.

    /**
     * @inheritDoc
     */

  }, {
    key: "focusLast",
    value: function focusLast() {} // The dropdown panel expects DropdownPanelFocusable interface on views passed to dropdown panel. See #30.
    // The method should be implemented while working on keyboard support for this view. See #22.

    /**
     * Highlights grid boxes depending on rows and columns selected.
     *
     * @private
     */

  }, {
    key: "_highlightGridBoxes",
    value: function _highlightGridBoxes() {
      var rows = this.rows;
      var columns = this.columns;
      this.items.map(function (boxView, index) {
        // Translate box index to the row & column index.
        var itemRow = Math.floor(index / 10);
        var itemColumn = index % 10; // Grid box is highlighted when its row & column index belongs to selected number of rows & columns.

        var isOn = itemRow < rows && itemColumn < columns;
        boxView.set('isOn', isOn);
      });
    }
  }]);

  return InsertTableView;
}(View);
/**
 * A single grid box view element.
 *
 * This class is used to render the table size selection grid in {@link module:table/ui/inserttableview~InsertTableView}.
 *
 * @private
 */


export { InsertTableView as default };

var TableSizeGridBoxView =
/*#__PURE__*/
function (_View2) {
  _inherits(TableSizeGridBoxView, _View2);

  /**
   * @inheritDoc
   */
  function TableSizeGridBoxView(locale) {
    var _this2;

    _classCallCheck(this, TableSizeGridBoxView);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(TableSizeGridBoxView).call(this, locale));
    var bind = _this2.bindTemplate;
    /**
     * Controls whether the grid box view is "on".
     *
     * @observable
     * @member {Boolean} #isOn
     */

    _this2.set('isOn', false);

    _this2.setTemplate({
      tag: 'div',
      attributes: {
        class: ['ck-insert-table-dropdown-grid-box', bind.if('isOn', 'ck-on')]
      },
      on: {
        mouseover: bind.to('over')
      }
    });

    return _this2;
  }

  return TableSizeGridBoxView;
}(View);